import React from "react";

const TermCondition = () => {
  return (
    <div className="container-fluid">
      <div className="p-4">
        <h3
          className="text-center"
          style={{ color: "#1d364d", fontWeight: "600" }}
        >
          Terms & Condition
        </h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio
          doloremque inventore commodi qui modi ad expedita? Nulla in eum totam
          ipsum doloribus magni autem harum, ducimus repellendus ratione tempora
          velit rem cupiditate eveniet voluptas vel atque facilis, accusamus
          voluptatum laudantium quis repellat, quae eaque? Dolor illo ab rem
          dicta commodi explicabo, ratione in sint architecto nam, eius
          voluptatum nostrum inventore asperiores. Totam numquam magnam officiis
          officia autem magni recusandae repellendus itaque ipsam voluptatibus
          eligendi, exercitationem, ex consequatur rem esse aspernatur atque.
          Fugiat quibusdam ea, sit aliquam deleniti adipisci illo consectetur.
          Debitis veritatis amet similique soluta, aperiam officia est optio
          molestiae magni ullam? Aspernatur debitis veritatis hic esse sed
          mollitia asperiores quis libero enim itaque deserunt assumenda in
          accusantium quas perferendis ab quae aliquid, consequuntur
          reprehenderit corrupti illo eos. Voluptatibus facere sunt
          reprehenderit tempore nemo quas cupiditate cum ipsam repellendus,
          dicta, ad dignissimos placeat architecto, provident magni inventore
          minima et unde.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Soluta
          dolorum, reiciendis animi consequuntur reprehenderit, minus blanditiis
          aspernatur ratione distinctio dolorem consectetur accusantium officia
          hic corporis accusamus cumque atque ex ut saepe eveniet alias.
          Adipisci hic nesciunt, aut, provident ipsum ipsam excepturi aliquam
          doloribus deserunt harum, maxime molestiae perferendis ducimus commodi
          consequuntur sapiente nihil ut dolore? Fugit, ut. Unde, animi incidunt
          eveniet culpa voluptatum et sed tempora deserunt facere molestiae
          ipsum eum in fuga recusandae doloribus quisquam inventore similique
          necessitatibus quis maxime nihil. Assumenda reprehenderit quibusdam
          magnam aut officiis illum, quia rerum porro veniam ipsum voluptatum
          nihil, doloribus necessitatibus non incidunt.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Explicabo
          voluptate saepe asperiores minus beatae molestias culpa rerum
          voluptates voluptatem ut, exercitationem dolore obcaecati repellendus
          itaque alias magni nobis temporibus totam quis, nihil laboriosam.
          Mollitia ea nihil dignissimos rem impedit. Harum tempora voluptates
          excepturi voluptatibus doloribus reiciendis ex ducimus, provident odit
          temporibus magnam nobis suscipit beatae illo dignissimos ullam velit
          blanditiis maxime quasi error possimus fugit at! Facere ex eveniet
          magni sequi voluptas ab temporibus at quis minus, est nulla possimus
          nam illo dolores, praesentium voluptates cum cupiditate ipsum corporis
          sed consectetur debitis amet rem? Molestias recusandae laborum
          temporibus libero, rerum itaque ducimus minima enim molestiae
          reprehenderit harum dolorum quaerat ullam sed quo ipsam laboriosam ad
          sit iure magnam natus tenetur.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Explicabo
          voluptate saepe asperiores minus beatae molestias culpa rerum
          voluptates voluptatem ut, exercitationem dolore obcaecati repellendus
          itaque alias magni nobis temporibus totam quis, nihil laboriosam.
          Mollitia ea nihil dignissimos rem impedit. Harum tempora voluptates
          excepturi voluptatibus doloribus reiciendis ex ducimus, provident odit
          temporibus magnam nobis suscipit beatae illo dignissimos ullam velit
          blanditiis maxime quasi error possimus fugit at! Facere ex eveniet
          magni sequi voluptas ab temporibus at quis minus, est nulla possimus
          nam illo dolores, praesentium voluptates cum cupiditate ipsum corporis
          sed consectetur debitis amet rem? Molestias recusandae laborum
          temporibus libero, rerum itaque ducimus minima enim molestiae
          reprehenderit harum dolorum quaerat ullam sed quo ipsam laboriosam ad
          sit iure magnam natus tenetur.
        </p>
      </div>
    </div>
  );
};

export default TermCondition;
